import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AlertService, JhiLanguageService} from 'ng-jhipster';
import {Referent} from './referent.model';
import {ReferentService} from './referent.service';
import {CandidatureFormation} from '../candidature';
import {Piece, PieceService, Question, QuestionService} from '../formation';
// noinspection TypeScriptPreferShortImport
import {ReponseService} from '../candidature/formation/reponse.service';
import {Observable} from 'rxjs';
// noinspection TypeScriptPreferShortImport
import {Reponse} from '../candidature/formation/reponse.model';
import {ConfirmationService} from 'primeng/components/common/api';
import {TranslateService} from 'ng2-translate';
import {Response} from "@angular/http";
import {PieceJointe, PieceJointeService} from "../piece-jointe";
import {PageScrollInstance, PageScrollService} from 'ng2-page-scroll';
import {DOCUMENT} from "@angular/platform-browser";
import {JhiAlertComponent} from "../../shared";
import {ParametrageService} from "../parametrage";

@Component({
    selector: 'jhi-referent-detail',
    templateUrl: './referent-detail.component.html'
})
export class ReferentDetailComponent implements OnInit {

    referent: Referent;
    questions: Question[];
    candidatureFormation: CandidatureFormation;
    isSaving = false;
    radios: any[] = [];
    firstValid = false;
    currentLang: string;
    lettreRecommandation: Piece;
    uploadedFiles: any[] = [];
    otherUploadedFiles: any[] = [];
    piecesJointes: PieceJointe[] = [];
    lastIdx: number;
    alertId: number;
    urlEnSavoirPlusDiplome: string;

    constructor(private jhiLanguageService: JhiLanguageService,
                private alertService: AlertService,
                private referentService: ReferentService,
                private translate: TranslateService,
                private reponseService: ReponseService,
                private questionService: QuestionService,
                private confirmationService: ConfirmationService,
                private translateService: TranslateService,
                private route: ActivatedRoute,
                private pieceService: PieceService,
                private pieceJointeService: PieceJointeService,
                private pageScrollService: PageScrollService,
                private parametrageService: ParametrageService,
                @Inject(DOCUMENT) private document: any) {
        this.jhiLanguageService.setLocations(['referent', 'global']);
        this.translate.onLangChange.subscribe(lang => this.currentLang = lang.lang);
    }


    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            let key = params['key'];
            let getReferent = this.referentService.get(key);
            let getPiece = this.pieceService.findByCode("LETTRE_RECOMMANDATION");
            Observable.forkJoin([getReferent, getPiece]).subscribe(results => {
                this.referent = results[0].json();
                this.lettreRecommandation = results[1];
                this.pieceJointeService.findByReferent(this.referent.id, this.referent.key, this.lettreRecommandation.id, this.referent.candidatureFormationId).subscribe((piecesJointeResp: Response) => {
                    this.piecesJointes.push(piecesJointeResp);
                    this.piecesJointes.forEach(pj => {
                             this.uploadedFiles[pj.pieceId] = pj;
                    });

                });

                this.getListeQuestions(this.referent.id);
            }, error => this.onError(error));
        });
        this.parametrageService.queryURLenSavoirPlusDiplome().subscribe(
            (res: Response) => {
                if (res != null && res.json() != null && res.json().length > 0) {
                    this.urlEnSavoirPlusDiplome = res.json()[0].libelle;
                }
            }
            ,
            (res: Response) => this.onError(res)
        );
    }

    /*   private getReferent(key) {
           this.referentService.get(key).subscribe((res) => {
               this.error = null;
               this.referent = res.json();
               this.getListeQuestions(this.referent.id);
           }, (error) => this.onError(error));
       }
   */
    private getListeQuestions(referentId) {
        if (referentId != null) {
            let getQuestions = this.questionService.query();
            let getReponses = this.reponseService.query({
                referentId: this.referent.id,
                referentKey: this.referent.key
            });
            Observable.forkJoin([getQuestions, getReponses]).subscribe(results => {
                this.questions = results[0].json();
                let reponses: Reponse[] = results[1] != null ? results[1].json() : [];

                this.questions.forEach(question => {
                    question.referentId = this.referent.id;
                    let rep = reponses.find(r => question.id === r.question.id);
                    if (rep) {
                        question.reponse = rep.response;
                    }
                });
                this.getRadios();
            }, error => this.onError(error));
        }
    }

    private getRadios() {
        if (this.questions != null) {
            this.questions.forEach(question => {
                if (question.typeReponse === 'RADIO' && question.reponseComplement != null) {
                    let choix = question.reponseComplement.split('|');
                    let idx = this.radios.map(radio => radio.join('|')).indexOf(question.reponseComplement);
                    if (idx < 0) {
                        this.radios.push(choix);
                    }
                }
            });
        }
    }

    save() {
        let questionsOblig = this.questions.filter(question => this.isQuestionObligatoire(question) === true && question.reponse == null);
        if (questionsOblig == null || questionsOblig.length === 0) {
            this.confirmationService.confirm({
                message: this.translateService.instant('cadensApp.referent.transmit.question'),
                header: this.translateService.instant('cadensApp.referent.transmit.title'),
                icon: 'fa fa-save',
                accept: () => {
                    this.referent.savedDate = new Date();
                    this.saveForLater();
                }
            });
        } else {
            this.firstValid = true;
            this.onErrorMessage('entity.validation.allRequired');
        }
    }

    saveForLater() {
        this.isSaving = true;
        let updateRefs = [this.referentService.update(this.referent, this.referent.key)];
        updateRefs.push(this.reponseService.updateAvecReferent(this.questions, this.referent.key));
        Observable.forkJoin(updateRefs).subscribe(result => {
            this.isSaving = false;
            this.alertService.success('cadensApp.referent.updated');
        }, error => {
            this.isSaving = false;
            this.onError(error);
        });
    }



    cancel() {
        this.ngOnInit();
    }

    // When the file is uploaded
    onFileUploaded(event, id) {
        let pj: PieceJointe = JSON.parse(event.xhr.response);
        if (this.uploadedFiles[id] == null) {
            this.uploadedFiles[id] = {nom: pj.nom};
        } else {
            this.uploadedFiles[id].nom = pj.nom;
        }
        if (this.piecesJointes.find(p => p.pieceId === id)) {
            this.piecesJointes.find(p => p.pieceId === id).nom = pj.nom;
        } else {
            this.piecesJointes.push(pj);
        }
        let pageScrollInstance: PageScrollInstance = PageScrollInstance.simpleInstance(this.document, '#transmit');
        this.scroll(this.pageScrollService,pageScrollInstance) ;
    }

    scroll(scrollService, scrollInstance){
        setTimeout(function() {
            scrollService.start(scrollInstance);
        }, 1000);
    }


    // Before the file is sent to the server for upload
    onBeforeSend(event) {
       event.xhr.setRequestHeader('X-XSRF-TOKEN', this.getCookie('XSRF-TOKEN'));
    }

    // Before the file is sent to the server for upload
    onBeforeUpload(event, id) {
        event.formData.append('pieceId', id);
        if (this.otherUploadedFiles != null && id === 1 && this.lastIdx != null
            && this.otherUploadedFiles[this.lastIdx] != null) {
            event.formData.append('pieceJointeId',
                this.otherUploadedFiles[this.lastIdx].id == null ? -1 : this.otherUploadedFiles[this.lastIdx].id);
        }
        this.alertId = id;
        event.formData.append('candidatureFormationId', this.referent.candidatureFormationId);
        event.formData.append('referentId', this.referent.id);
        event.formData.append('referentKey', this.referent.key);
    }

    // Before the file is sent to the server for upload
    // noinspection JSMethodCanBeStatic
    onRemove(event, id) {
        event.formData.append('pieceId', id);
    }

    // noinspection JSMethodCanBeStatic
    private getCookie(name) {
        let value = '; ' + document.cookie;
        let parts = value.split('; ' + name + '=');
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
    }

    // Open a file in a new tab when click on it
    openFile(name: string) {
        // Get la liste des pièces jointes déjà uploadées
        this.pieceJointeService.openFile(name)
            .subscribe((res) => {
                let fileUrl = URL.createObjectURL(res);
                window.open(fileUrl);
            });
    }

    // noinspection JSMethodCanBeStatic
    avantDerniereQuestion(question : Question): Boolean {
        return question.libelle.includes("conclusion") && question.typeReponse == "RADIO";
    }

    isQuestionObligatoire(question : Question){
        if ( this.avantDerniereQuestion(question) || this.uploadedFiles[this.lettreRecommandation.id]==null){
            return question.obligatoire == true;
        }else{
            return false ;
        }
    }

    onError(response: Response) {
        JhiAlertComponent.onError(this.alertService, response);
    }

    onErrorMessage(message: any) {
        JhiAlertComponent.onErrorMessage(this.alertService, message, null);
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/referent/referent-detail.component.ts